<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Nro.Orden"
          label-for="numeroOrdenCompra"
          description="Número de orden de compra"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="numeroOrdenCompra"
            v-model.trim="$v.numeroOrdenCompra.$model" 
            :state="numeroOrdenCompraValida"
            type="text">
          </b-form-input>
          <b-form-invalid-feedback id="numeroOrdenCompraFeedback">
            {{ numeroOrdenCompraInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="actualizarNumeroOrdenCompra">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelarNumeroOrdenCompra">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'OrdenCompraNumero',
  data: () => {
    return {
      numeroOrdenCompra: '',
      numeroOrdenCompraValida: null,
      numeroOrdenCompraInvalidaMsj: '',
    }
  },
  created() {
  },  
  methods: {
    actualizarNumeroOrdenCompra() {
      this.$v.$touch();

      if (this.$v.numeroOrdenCompra.$error) {
        this.numeroOrdenCompraValida = false;
        if (!this.$v.numeroOrdenCompra.required) {
          this.numeroOrdenCompraInvalidaMsj = 'Debe ingresar el número de orden de compra.';
        } else if (!this.$v.numeroOrdenCompra.maxLength) {
          this.numeroOrdenCompraInvalidaMsj = 'El número de orden de compra solo puede contener hasta 150 caracteres.';
        }      
      } else {
        this.numeroOrdenCompraValida = null;
        this.numeroOrdenCompraInvalidaMsj = '';
      }

      if (!this.$v.$anyError) {
        this.$emit('actualizarNumeroOrdenCompra', this.numeroOrdenCompra)
      }
    },
    cancelarNumeroOrdenCompra() {
      this.$emit('cancelarNumeroOrdenCompra')
    }
  },
  validations: {
    numeroOrdenCompra: {
      required,
      maxLength: maxLength(150)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
